// Copy WKT / Copy GeoJSON footer buttons for the peek + expanded-dialog geometry preview — split out
// of SpatialGeometryPreview.tsx to keep it under the repo 200-line cap. `onCopy` runs the parent's
// clipboard write, which fires the copy analytics on success (and, for a curved geometry, keeps the
// copied WKT curved via the parent's toWktForExport path).
import { Copy } from 'lucide-react';
import { Button } from '../../../../components/ui/button';

type Props = { onCopy: (format: 'wkt' | 'geojson') => void };

export function SpatialPreviewCopyButtons({ onCopy }: Props) {
  return (
    <span className="flex shrink-0 items-center gap-1">
      <Button
        type="button"
        size="sm"
        variant="ghost"
        className="h-6 px-2 text-[11px]"
        onClick={() => onCopy('wkt')}
        data-testid="spatial-peek-copy-wkt"
      >
        <Copy className="mr-1 h-3 w-3" aria-hidden="true" />
        Copy WKT
      </Button>
      <Button
        type="button"
        size="sm"
        variant="ghost"
        className="h-6 px-2 text-[11px]"
        onClick={() => onCopy('geojson')}
        data-testid="spatial-peek-copy-geojson"
      >
        <Copy className="mr-1 h-3 w-3" aria-hidden="true" />
        Copy GeoJSON
      </Button>
    </span>
  );
}
